import axios from './axiosConfig';

//const API_URL = "https://api.demo2.raborisk.ai";

const API_URL = process.env.NODE_ENV === 'production' 
    ? "https://api.demo2.raborisk.ai" 
    : "http://localhost:3000";


export const editNotificationUser = (department_id, user_id, notify_assign_task, notify_deadline, notify_comment, notify_delete_risk, notify_delete_control, notify_delete_action, notify_modify_timeline) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/department/edit_notification_user", { department_id, user_id, notify_assign_task, notify_deadline, notify_comment, notify_delete_risk, notify_delete_control, notify_delete_action, notify_modify_timeline })
            .then(({ data }) => {
                dispatch({ type: "NOTIFICATIONS_SETTINGS", notifications: data });
            });
    };
};

export const removeNotificationUser = (department_id, user_id) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/department/remove_notification_user", { department_id, user_id })
            .then(({ data }) => {
                dispatch({ type: "NOTIFICATIONS_SETTINGS", notifications: data });
            });
    };
};

export const addNotificationUser = (department_id, user_id) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/department/add_notification_user", { department_id, user_id })
            .then(({ data }) => {
                dispatch({ type: "NOTIFICATIONS_SETTINGS", notifications: data });
            });
    };
};


export const getNotificationsSettings = (department_id) => {
    return (dispatch) => {
        axios.get(API_URL + "/api/department/get_notifications_settings/" + department_id)
            .then(({ data }) => {
                dispatch({ type: "NOTIFICATIONS_SETTINGS", notifications: data });
            });
    };
};

export const getDepartmentName = async (department_id) => {
    const { data } = await axios.get(API_URL + "/api/department/get_department_name/" + department_id);
    return data;
};

export const getAllDepartments = () => {
    return (dispatch) => {
        axios.get(API_URL + "/api/department/get_all_departments")
            .then(({ data }) => {
                console.log("All Depts", data);
                dispatch({ type: "ALL_DEPARTMENTS", all_departments: data.departments });
            })
            .catch((error) => {
                console.error("Error fetching departments:", error);
            });
    };
};




export const openDepartmentDashboard = (department_id) => {
    return { type: "OPEN_DEPARTMENT_DASHBOARD", department_id };
};

export const resetDepartmentDashboard = () => {
    return { type: "RESET_DEPARTMENT_DASHBOARD" };
};


export const editActionComments = (comment_iid, comments, department_id) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/department/edit_action_comments", { comment_iid, comments, department_id })
            .then(({ data }) => {
                console.log("edit comment:" , data)
                dispatch({ type: "ACTIONS", actions: data });
            });
    };
};

export const addActionComments = (action_id, comments, department_id) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/department/add_action_comments", { action_id, comments, department_id })
            .then(({ data }) => {
                console.log("edit comment:" , data)
                dispatch({ type: "ACTIONS", actions: data });
            });
    };
};


export const getDepartmentsAction = (department_id) => {
    console.log("department_id", department_id)
    return (dispatch) => {
        axios.get(API_URL + "/api/department/get_departments_actions/" + department_id)
            .then(({ data }) => {
                console.log("get Actions:" , data)
                dispatch({ type: "ACTIONS", actions: data });
            });
    };
};

export const getDepartmentsActionData = (department_id) => {
  return (dispatch) => {
    console.log("department_id", department_id);
    // return the whole axios chain
    return axios
      .get(API_URL + "/api/department/get_departments_actions_data/" + department_id)
      .then(({ data }) => {
        console.log("get Actions:", data);
        dispatch({ type: "ACTIONS_DATA", actions: data });
        return data; // now this will be available to the caller
      });
  };
};

export const getDepartmentsFindings = (department_id) => {
  return (dispatch) => {
    console.log("department_id", department_id);
    return axios
      .get(API_URL + "/api/department/get_departments_findings/" + department_id)
      .then(({ data }) => {
        console.log("get Findings:", data);
        dispatch({ type: "FINDINGS_DATA", findings: data });
        return data; // available to the caller
      })
      .catch((err) => {
        console.error("Error fetching findings:", err);
        throw err;
      });
  };
};

export const getProcedures = (department_id) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/department/get_procedures", { department_id })
            .then(({ data }) => {
                //dispatch({ type: "POLICIES", departments: data });
            });
    };

};


export const setActiveDepartment = (department_id) => {
    console.log("new Dep ", department_id)
    return { type: "SET_ACTIVE_DEPARTMENT", department_id };
};


export const addProcedure = (department_id, data) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/department/add_procedure", { department_id, details: data })
            .then(({ data }) => {
                //dispatch({ type: "POLICIES", departments: data });
            });
    };
};

export const updateDepartment = (department_id, data) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/department/update_department", { department_id, data: data })
            .then(({ data }) => {
                //
                dispatch({ type: "POLICIES", departments: data });
                //dispatch({ type: "UPDATE_DEPARTMENT", department: data });
            });
    };
};

export const deleteDepartment = (department_id) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/department/delete_department", { department_id: department_id })
            .then(({ data }) => {
                dispatch({ type: "DEPARTMENTS", departments: data });
            });
    };
};

export const resetNewlycreatedDepartmentId = () => {
    return { type: "RESET_NEWLYCREATED_DEPARTMENT_ID" };
};

export const createDepartment = () => {
    return (dispatch) => {
        axios.post(API_URL + "/api/department/create_department")
            .then(({ data }) => {
                dispatch({ type: "DEPARTMENT_CREATED", departments: data.departments, newlycreatedDepartmentId: data.department_id });
            });
    };
};

export const resetDepartment = () => {
    return { type: "RESET_DEPARTMENT" };
};

export const openDepartment = (department_id) => {
    return { type: "OPEN_DEPARTMENT", department_id };
};

export const getDepartments = () => {
    return (dispatch) => {
        axios.get(API_URL + "/api/department/get_departments")
            .then(({ data }) => {
                dispatch({ type: "DEPARTMENTS", departments: data });
            });
    };
};


export const addAttachment = (department_id, policy_id, file) => {
    return (dispatch) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('department_id', department_id);
        formData.append('policy_id', policy_id);

        axios.post(API_URL + "/api/department/add_attachment_procedure", formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(({ data }) => {
                //dispatch({ type: "POLICIES", departments: data });
            })
            .catch(error => {
                console.error('Error uploading file:', error);
            });
    };
};

export const editProcedure = (department_id, policy_id, policy) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/department/edit_procedure", { department_id: department_id, policy_id: policy_id, policy: policy })
            .then(({ data }) => {
                //dispatch({ type: "POLICIES", departments: data });
            });
    };
};

